import * as React from 'react';
import { useFragment } from 'react-relay';
import { fundsListDownloadFragment } from './FundsListDownload.relay';
import type { FundsListDownloadPropsType } from './types';

const FundsListDownload: React.FC<FundsListDownloadPropsType> = ( props: FundsListDownloadPropsType ) => {
    const fundsListDownload = useFragment( fundsListDownloadFragment, props.fundsListDownload );

    const link = fundsListDownload.url + '?salesAdmission=' + props.salesAdmission;
    return (
        <a
            href={ link }
            className={ props.className }>{fundsListDownload.label}
        </a>
    );
};

export { FundsListDownload };
